// Общая конфигурация навигации кабинета (редизайн)
// Соцсети проекта (блок сообщества в сайдбаре и на CFP)
export const SOCIAL_LINKS = [
    {key: 'telegram', label: 'Telegram', url: 'https://t.me/fthefomo'},
    {key: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@FCKTHEFOMO'},
    {key: 'x', label: 'X', url: 'https://x.com/Fuckthefomo'},
    {key: 'medium', label: 'Medium', url: 'https://medium.com/@Fckthefomo'},
];

export const DISCORD_URL = 'https://discord.gg/E5GN3zFc';
export const SITE_URL = `${process.env.REACT_APP_NEXT_LINK || ''}/`;
// TODO: подставить ссылку на whitepaper
export const WHITEPAPER_URL = process.env.REACT_APP_WHITEPAPER_URL || '';

export const NAV_ITEMS = [
    {path: 'matrix', label: 'CFP', icon: 'cfp', tab: 'CFP'},
    {path: 'wallet', label: 'Кошелек и обмен', icon: 'wallet', tab: 'Кошелек'},
    {path: 'roadmap', label: 'Дорожная карта', icon: 'roadmap', tab: 'Дорожная карта'},
    {path: 'leaderboard', label: 'Таблица лидеров', icon: 'leaderboard', tab: 'Лидеры'},
    {path: 'referral-program', label: 'Реферальная программа', icon: 'users'},
    {path: 'contests', label: 'Розыгрыши', icon: 'gift'},
    {path: 'settings', label: 'Настройки', icon: 'settings'},
    {path: 'events', label: 'События', icon: 'calendar'},
    {path: 'transactions', label: 'Транзакции', icon: 'list'},
];

// первые 4 пункта — в нижнем таб-баре, остальные — в «Ещё»
export const TAB_ITEMS = NAV_ITEMS.slice(0, 4);
export const MORE_ITEMS = NAV_ITEMS.slice(4);

export const isActivePath = (pathname, page) =>
    pathname === `/${page}` || pathname.startsWith(`/${page}/`);

export const formatNumber = (value, maxDigits = 2) =>
    new Intl.NumberFormat('en-US', {maximumFractionDigits: maxDigits}).format(Number(value) || 0);

// Компактный формат для узких мест (мобильная шапка): 1250 → 1.25K
export const formatCompact = (value) => {
    const n = Number(value) || 0;
    if (Math.abs(n) < 1000) return formatNumber(n);
    return new Intl.NumberFormat('en-US', {notation: 'compact', maximumFractionDigits: 2}).format(n);
};

export const shortAddress = (addr) =>
    addr && addr.length > 10 ? `${addr.slice(0, 4)}...${addr.slice(-4)}` : (addr || '—');
